<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <div class="content-area" [userPermissionHandler]="viewPermissionHandlerData">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="fw-semibold">{{'Vendor' | wordReplace}} Adjustments</h5>
                <button class="btn btnAS" [userPermissionHandler]="createPermissionHandlerData"
                    (click)="onNewClick()">New</button>
            </div>
            <hr />
            <h6>{{'Vendor' | wordReplace}} Adjustments</h6>
            <div class="row">
                <div class="col-12 text-start">
                    <div class="grid-wrapper position-relative">
                        <div class="block-ui" *ngIf="loaderIcon | async">
                            <app-loader></app-loader>
                        </div>
                        <ejs-grid #gridPosVendorAdjustment [dataSource]="paymentData" height="300"
                            (dataBound)='dataBound($event)' (rowSelected)="onRowSelected($event)"
                            [allowFiltering]="true" (created)='created($event)'>
                            <e-columns>
                                <e-column field="SlNo" headerText="SL#" width="80" textAlign="Center"></e-column>
                                <e-column field="DealerID" headerText="{{'Vendor' | wordReplace}} ID"
                                    width="120"></e-column>
                                <e-column field="DealerName" headerText="{{'Vendor' | wordReplace}} Name"
                                    width="200"></e-column>
                                <e-column field="CashPayment" headerText="Cash Payment" width="150"
                                    textAlign="Right"></e-column>
                                <e-column field="CheckPayment" headerText="Check Payment" width="150"
                                    textAlign="Right"></e-column>
                                <e-column field="CheckNo" headerText="Check #" width="150"></e-column>
                                <e-column field="TotalPayment" headerText="Total Payment" width="150"
                                    textAlign="Right"></e-column>
                                <e-column field="ActionType" headerText="Action Type" width="150"></e-column>
                                <e-column field="Delete" headerText="Delete" width="100" textAlign="Center">
                                    <ng-template #template let-data>
                                        <span class="Delete" style="position: relative;">
                                            <button class="btn btn-link w-100 h-100 p-0"
                                                [userPermissionHandler]="deletePermissionHandlerData"
                                                (click)="$event.stopPropagation(); $event.preventDefault(); onDelete(data, $event)">
                                                <img src="./assets/images/delete.svg" class="img-fluid" />
                                            </button>
                                        </span>
                                    </ng-template>
                                </e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal -->
        <div class="modal fade" id="vendorAdjustmentModal" #vendorAdjustmentModal tabindex="-1"
            aria-labelledby="evendorAdjustmentModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="vendorAdjustmentModalLabel">Adjustment Details</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <form class="row g-3" [formGroup]="VendorAdjustmentForm">
                            <div class="col-md-12 col-lg-9">
                                <div class="row">
                                    <div class="col-12 text-start">
                                        <label for="dealerId" class="form-label">{{'Vendor' | wordReplace}} ID <span
                                                class="required">*</span></label>
                                    </div>
                                    <div class="col-3">
                                        <input type="text" class="form-control me-1" id="dealerId"
                                            formControlName="marketVendorId" (blur)="getVendorById()">
                                        <input type="hidden" formControlName="vendorSeqId">
                                        <input type="hidden" formControlName="AdjId">
                                        <div *ngIf="VendorAdjustmentForm.get('marketVendorId')?.touched && VendorAdjustmentForm.get('marketVendorId')?.invalid"
                                            class="text-danger">
                                            {{'Vendor' | wordReplace}} ID is required.
                                        </div>
                                    </div>
                                    <div class="col-5">
                                        <input type="text" class="form-control" formControlName="vendorName" readonly>
                                    </div>
                                    <div class="col-2">
                                        <button type="button" class="btn btn-dark" (click)="openVendorModal()">
                                            <img src="./assets/images/search.svg" class="img-fluid" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <label for="cashPayment1" class="form-label">Cash Payment</label>
                                <input type="text" style="text-align:right" class="form-control" id="cashPayment1"
                                    formControlName="cashPayment" (blur)="onCashPaymentBlur()"
                                    (keypress)="numberOnly($event)" maxlength="8">
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <label for="cashPayment2" class="form-label">Check Payment</label>
                                <input type="text" style="text-align:right" class="form-control" id="cashPayment2"
                                    formControlName="checkPayment" (blur)="onCheckPaymentBlur()"
                                    (keypress)="numberOnly($event)" maxlength="8">
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <label for="checkNumber" class="form-label">Check Number</label>
                                <input type="text" class="form-control" id="checkNumber" formControlName="checkNumber"
                                    maxlength="20">
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <label for="amount" class="form-label">Amount</label>
                                <input type="text" style="text-align:right" class="form-control" id="amount"
                                    formControlName="totalAmount">
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <label for="actionType" class="form-label">Action Type <span
                                        class="required">*</span></label>
                                <select class="form-select" id="actionType" formControlName="actionType">
                                    <option value="">-- Select Action Type --</option>
                                    <option value="0">Add to Vendor Due-(Debit)</option>
                                    <option value="1">Subtract from Vendor Due-(Credit)</option>
                                </select>
                                <div *ngIf="VendorAdjustmentForm.get('actionType')?.touched && VendorAdjustmentForm.get('actionType')?.invalid"
                                    class="text-danger">
                                    Action Type is required.
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-4">
                                <label for="dateEntry" class="form-label">Date Entry </label>
                                <ejs-datepicker class="form-control p-0" formControlName="adjDate"
                                    [min]="lastPayoutDate"></ejs-datepicker>
                            </div>
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-12">
                                        <label class="form-label">Terminal &amp; User Name</label>
                                    </div>

                                    <div class="col-md-8">
                                        <input type="text" class="form-control"
                                            [value]="VendorAdjustmentForm.get('terminalName')?.value + '/' + VendorAdjustmentForm.get('userName')?.value"
                                            readonly>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <label for="description" class="form-label">Description <span
                                        class="required">*</span></label>
                                <textarea class="form-control" id="description" rows="2" formControlName="description"
                                    maxlength="50"></textarea>
                                <div *ngIf="VendorAdjustmentForm.get('description')?.touched &&
         VendorAdjustmentForm.get('description')?.invalid" class="text-danger">
                                    Description is required.
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        @if (isEditMode) {
                        <button type="button" class="btn btnAS me-1" [userPermissionHandler]="editPermissionHandlerData"
                            (click)="onSave()" [disabled]="VendorAdjustmentForm.invalid || !VendorAdjustmentForm.dirty">
                            Save
                        </button>
                        } @else {
                        <button type="button" class="btn btnAS me-1"
                            [userPermissionHandler]="createPermissionHandlerData"
                            [disabled]="VendorAdjustmentForm.invalid" (click)="onSave()">
                            Save
                        </button>
                        }
                        <button type="button" class="btn btn-orange" data-bs-dismiss="modal">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal with Vendor Search Component -->
        <div class="modal fade" id="vendorSearchModal" #vendorSearchModal tabindex="-1"
            aria-labelledby="vendorSearchLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="vendorSearchLabel">
                            {{'Select Vendor' | wordReplace}}
                        </h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <app-vendor-search [isVendorPopUp]="true" [VendorFilterOption]="VendorFilterOption"
                            (vendorSearchRoute)="onVendorSelected($event)">
                        </app-vendor-search>
                    </div>
                </div>
            </div>
        </div>
    </div>